/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';
export const getServerPages = async () => {
  const Components = {};
  if (ssr) {
    Components.colorWall = (await import('./pages/color-wall/ColorWallContainer')).ColorWallContainer;
    Components.browse = (await import('./pages/browse-search/BrowseAndSearchContainer')).BrowseAndSearchContainer;
    Components.browseMobile = (await import('./pages/browse-search/BrowseAndSearchMobileContainer')).BrowseAndSearchMobileContainer;
    Components.search = (await import('./pages/browse-search/BrowseAndSearchContainer')).BrowseAndSearchContainer;
    Components.searchMobile = (await import('./pages/browse-search/BrowseAndSearchMobileContainer')).BrowseAndSearchMobileContainer;
    Components.pep = (await import('./pages/pep/PepDesktopContainer')).PepDesktopContainer;
    Components.pepMobile = (await import('./pages/pep/PepMobileContainer')).PepMobileContainer;
    Components.product = (await import('./pages/product/ProductContainer')).ProductContainer;
    Components.productMobile = (await import('./pages/product/ProductMobileContainer')).ProductMobileContainer;
    Components.compare = (await import('./pages/compare/CompareContainer')).CompareContainer;
    Components.home = (await import('./pages/Home')).Home;
  }
  return Components;
};

export const getRoutes = (currentRouteName, currentRouteComponent, serverPages) => (
  {
    colorWall: {
      name: 'ColorWallContainer',
      componentName: 'ColorWallContainer',
      chunk: () => import('./pages/color-wall/ColorWallContainer'),
      get component() {
        return ssr
          ? serverPages.colorWall
          : currentRouteName === 'ColorWallContainer'
            ? currentRouteComponent
            : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ColorWallContainer })));
      },
      path: '/:context?/b/Paint-Ideas/:color?/:navbarIndex?/:brand?',
      channel: null
    },
    browse: {
      name: 'BrowseAndSearchContainer',
      componentName: 'BrowseAndSearchContainer',
      chunk: () => import('./pages/browse-search/BrowseAndSearchContainer'),
      get component() {
        return ssr
        // eslint-disable-next-line max-len
          ? serverPages.browse
          : currentRouteName === 'BrowseAndSearchContainer'
            ? currentRouteComponent
          // eslint-disable-next-line max-len
            : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.BrowseAndSearchContainer })));
      },
      path: '/:context?/:bassPV?/b/*',
      channel: 'desktop'
    },
    browseMobile: {
      name: 'BrowseAndSearchMobileContainer',
      componentName: 'BrowseAndSearchMobileContainer',
      chunk: () => import('./pages/browse-search/BrowseAndSearchMobileContainer'),
      get component() {
        return ssr
        // eslint-disable-next-line max-len
          ? serverPages.browseMobile
          : currentRouteName === 'BrowseAndSearchMobileContainer'
            ? currentRouteComponent
          // eslint-disable-next-line max-len
            : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.BrowseAndSearchMobileContainer })));
      },
      path: '/:context?/b/*',
      channel: 'mobile'
    },
    search: {
      name: 'BrowseAndSearchContainer',
      componentName: 'BrowseAndSearchContainer',
      chunk: () => import('./pages/browse-search/BrowseAndSearchContainer'),
      get component() {
        return ssr
        // eslint-disable-next-line max-len
          ? serverPages.search
          : currentRouteName === 'BrowseAndSearchContainer'
            ? currentRouteComponent
          // eslint-disable-next-line max-len
            : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.BrowseAndSearchContainer })));
      },
      path: '/:context?/:bassPV?/s/*',
      channel: 'desktop'
    },
    searchMobile: {
      name: 'BrowseAndSearchMobileContainer',
      componentName: 'BrowseAndSearchMobileContainer',
      chunk: () => import('./pages/browse-search/BrowseAndSearchMobileContainer'),
      get component() {
        return ssr
        // eslint-disable-next-line max-len
          ? serverPages.searchMobile
          : currentRouteName === 'BrowseAndSearchMobileContainer'
            ? currentRouteComponent
          // eslint-disable-next-line max-len
            : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.BrowseAndSearchMobileContainer })));
      },
      path: '/:context?/s/*',
      channel: 'mobile'
    },
    pep: {
      name: 'PepDesktopContainer',
      componentName: 'PepDesktopContainer',
      chunk: () => import('./pages/pep/PepDesktopContainer'),
      get component() {
        return ssr
          ? serverPages.pep
          : currentRouteName === 'PepDesktopContainer'
            ? currentRouteComponent
            : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.PepDesktopContainer }))
            );
      },
      path: '/:context?/pep/:slug?/:itemId',
      channel: 'desktop'
    },
    // @TODO: Named export doesn't match the component file name.
    pepMobile: {
      name: 'PepMobileContainer',
      componentName: 'PepMobileContainer',
      chunk: () => import('./pages/pep/PepMobileContainer'),
      get component() {
        return ssr
          ? serverPages.pepMobile
          : currentRouteName === 'PepMobileContainer'
            ? currentRouteComponent
            : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.PepMobileContainer }))
            );
      },
      path: '/:context?/pep/:slug?/:itemId',
      channel: 'mobile'
    },
    product: {
      name: 'ProductContainer',
      componentName: 'ProductContainer',
      chunk: () => import('./pages/product/ProductContainer'),
      get component() {
        return ssr
          ? serverPages.product
          : currentRouteName === 'ProductContainer'
            ? currentRouteComponent
            : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ProductContainer })));
      },
      path: '/:context?/p/:slug?/:itemId',
      prefetch: ['browse'],
      channel: 'desktop'
    },
    productMobile: {
      name: 'ProductMobileContainer',
      componentName: 'ProductMobileContainer',
      chunk: () => import('./pages/product/ProductMobileContainer'),
      get component() {
        return ssr
        // eslint-disable-next-line max-len
          ? serverPages.productMobile
          : currentRouteName === 'ProductMobileContainer'
            ? currentRouteComponent
            : generateAsyncRoute(() => this.chunk()
              .then((pageModule) => ({ default: pageModule.ProductMobileContainer })));
      },
      path: '/:context?/p/:slug?/:itemId',
      prefetch: ['browseMobile'],
      channel: 'mobile'
    },
    compare: {
      name: 'CompareContainer',
      componentName: 'CompareContainer',
      chunk: () => import('./pages/compare/CompareContainer'),
      get component() {
        return ssr
          ? serverPages.compare
          : currentRouteName === 'CompareContainer'
            ? currentRouteComponent
            : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.CompareContainer })));
      },
      path: '/:context?/compare',
      channel: null
    },
    home: {
      name: 'Home',
      componentName: 'Home',
      chunk: () => import('./pages/Home'),
      get component() {
        return ssr
          ? serverPages.home
          : currentRouteName === 'Home'
            ? currentRouteComponent
            : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Home })));
      },
      path: '/:context?/',
      channel: null
    },
  }
);
